(() => {
  const track = (name, props) => {
    const sdk = window.exponea || window.brweb;
    if (!sdk || typeof sdk.track !== 'function') return;
    try {
      sdk.track(name, props);
    } catch {
      /* no-op */
    }
  };

  document.addEventListener('apa:wishlist:count', (event) => {
    const { productId, variantId, sku, inWishlist } = event.detail || {};
    if (productId == null || inWishlist === undefined) return;

    track('wishlist_update', {
      product_id: String(productId),
      ...(variantId && { variant_id: String(variantId) }),
      ...(sku && { sku }),
      action: inWishlist ? 'add' : 'remove',
    });
  });

  const headerLink = document.querySelector('.apc-header__wishlist');
  if (headerLink) {
    headerLink.addEventListener('click', () => {
      track('wishlist-click', { label: 'Header – Verlanglijstje' });
    });
  }
})();
